<template>
  <Card :title="title">
    <div v-if="loading" class="mb-4 text-gray-500">Loading Features Summary...</div>
    <div v-else>
      <p class="mb-4 text-gray-700">
        <span v-if="featureCount">
          {{ featureCount }} distinct features across {{ totalAccounts }} accounts. Most widely deployed: {{ topFeature.name }} ({{ topFeature.count }} accounts).
        </span>
        <span v-else>No feature data available.</span>
      </p>

      <ul class="mb-4 text-sm text-gray-800 list-disc list-inside">
        <li v-for="feat in sortedSummaryFeatures" :key="feat.name">
          <span class="font-bold">{{ feat.name }}</span>: {{ feat.count }} account<span v-if="feat.count !== 1">s</span>
        </li>
      </ul>

      <router-link
        :to="`/${id}/base2tools`"
        class="inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200"
      >
        View Detailed Features Report
        <svg xmlns="http://www.w3.org/2000/svg" class="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
      </router-link>
    </div>
  </Card>
</template>

<script>
import Card from '../Card.vue'
import HTTP from '../../../common/http'

export default {
  name: 'FeaturesCard',
  components: { Card },
  props: {
    id: { type: String, required: true },
    activeType: { type: String, required: true },
    title: { type: String, default: 'Features Summary' }
  },
  data () {
    return {
      loading: false,
      summary: {
        accounts: [],
        rawFeatures: {}
      }
    }
  },
  computed: {
    totalAccounts () {
      return this.summary.accounts.length
    },
    featureCount () {
      return Object.keys(this.summary.rawFeatures).length
    },
    summaryFeatures () {
      // Map feature name to unique account count
      return Object.entries(this.summary.rawFeatures).map(([name, entries]) => {
        const uniqueAccounts = new Set(entries.map(e => e.account_id))
        return { name, count: uniqueAccounts.size }
      })
    },
    sortedSummaryFeatures () {
      // Sort descending by count, then alphabetically for ties
      return [...this.summaryFeatures].sort((a, b) => {
        if (b.count !== a.count) return b.count - a.count
        return a.name.localeCompare(b.name)
      })
    },
    topFeature () {
      if (!this.summaryFeatures.length) return { name: '', count: 0 }
      return this.summaryFeatures.reduce((max, feat) =>
        feat.count > max.count ? feat : max,
      this.summaryFeatures[0])
    }
  },
  methods: {
    fetchSummary () {
      this.loading = true
      HTTP.get(`/base2tools/summary/${this.activeType}/${this.id}`)
        .then(res => {
          const data = res.data
          this.summary.accounts = data.accounts || []
          this.summary.rawFeatures = data.bearse_features || {}
        })
        .catch(err => console.error('Error fetching summary:', err))
        .finally(() => { this.loading = false })
    }
  },
  created () {
    this.fetchSummary()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/InfoCards/FeaturesCard.vue